import { getTheme, concatStyleSets } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var defaultStyles = function (theme) {
    return {
        root: {
            backgroundColor: theme.palette.white,
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflow: "auto"
        }
    };
};
var StyleConfig = {
    defaultStyles: defaultStyles
};
var getStyles = memoizeFunction(function (theme, customStyles) {
    return concatStyleSets(StyleConfig.defaultStyles(theme || getTheme()), customStyles);
});
export { getStyles, StyleConfig };
